module.exports = __webpack_public_path__ + "img/merchandise.c6029fc7.jpg";